<template>
    <div class="login_box">
        <div class="box2">
            <h5>SIMABA III IMP&EXP  S.L<br>后台管理系统</h5>
            <el-form ref="form" :model="form" >
                <el-form-item prop="username" :rules="
                [
					  { required: true, message: '账号为必填项'},
					]">
                    <el-input v-model="form.username" style="height:22px;"></el-input>
                </el-form-item>

                <el-form-item prop="pwd" :rules="[
					  { required: true, message: '密码为必填项'},
					]">
                    <el-input v-model="form.pwd" type="password" style="height:22px;" show-password></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitFrom">登录</el-button>
                </el-form-item>
            </el-form>

        </div>
    </div>
</template>

<script>
    import {
        login
    } from '../api/api'
    import local from '../utils/local'

    export default {
        data() {
            return {
                form: {
                    username: '',
                    pwd: ""
                },

            };
        },
        methods: {
            submitFrom() {
                this.$refs["form"].validate(valid => {
                    console.log(valid)
                    if (valid) {
                        login(this.form.username, this.form.pwd).then(res => {
                            if (res.data.status == 200) {
                                local.save("admin_id", res.data.data.admin_id);
                                this.$message({
                                    type: 'success',
                                    message: "登录成功"
                                });
                                this.$router.push('/home')
                            } else {
                                this.$message.error(res.data.msg);
                                // this.$message.error(res.data.data.msg)
                            }
                        })
                    }
                })




            }
        }
    };
</script>

<style lang="less" scoped>
.login_box{
    position:fixed;
    top: 0;
    left: 0;    
    width:100%;
    height:100%;
    min-width: 1000px;
    z-index:-10;
    zoom: 1;
    background-color: #fff;
    background-repeat: no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
     -o-background-size: cover;
    background-position: center 0;
    background: url('http://dev-216admin.clkseuropa.com/img/background.5825f033.svg');
}
    .box2 {
        width: 500px;
        // background-color: coral;
        margin: 0 auto;
        margin-top: 120px;
        text-align: center;

        h5 {
            font-size: 36px;
            margin-bottom: 24px;
            font-weight: normal;
            color: #333;
        }

        .el-form {
            .el-button {
                width: 100%;
            }
        }
    }
</style>